import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-resend-message-dialog',
  templateUrl: './resend-message-dialog.component.html',
  styleUrl: './resend-message-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ResendMessageDialog {
  protected dialogMessage: string | null = null;
  protected resendMessage: string | null = null;
  protected shouldResend: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string | null; }) {
    if (data && data.message) {
      this.dialogMessage = data.message;
    }
  }

}
